import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { setChatVisible } from 'features/chat/chatSlice';
import { useCurrentEvent } from 'features/events/eventHooks';
import { useSocialElementsDisabled } from 'features/channel/channelHooks';
import { Button } from 'components/Buttons/Button';
import { useAppSelector } from 'hooks/redux';
import { Icon } from 'components/Icons';

interface ChatButtonFloatingProps {
  isDisabled?: boolean;
}

export const ChatButtonFloating: FunctionComponent<ChatButtonFloatingProps> = (
  props
) => {
  const chatVisible = useAppSelector((state) => state.chat.isVisible);
  const dispatch = useDispatch();
  const event = useCurrentEvent();
  const newCommentCount = useAppSelector((state) => state.chat.newCommentCount);
  const hasNewComments = useAppSelector((state) => state.chat.hasNewComments);
  const isChatVisible = useAppSelector((state) => state.chat.isVisible);
  const socialElementsDisabled = useSocialElementsDisabled();
  const label = props.isDisabled ? 'Chat disabled' : 'Chat';

  const renderCountOrIcon = () => {
    if (hasNewComments) {
      return (
        <span className="tw-bg-theme-color tw-rounded-full tw-px-3 tw-block">
          {newCommentCount}
        </span>
      );
    } else {
      return <Icon icon={'chatOn'} label={''} height={20} width={20} />;
    }
  };

  if (socialElementsDisabled) {
    return null;
  }

  if ((event && !event.chatEnabled) || isChatVisible) {
    return null;
  }

  return (
    <Button
      onClick={() => {
        dispatch(setChatVisible(!chatVisible));
      }}
      disabled={props.isDisabled}
      className="tw-bg-white tw-text-black tw-fixed tw-bottom-4 tw-right-4 tw-inline-flex tw-w-auto tw-full tw-pl-3 tw-space-x-2 tw-items-center tw-h-auto tw-py-1"
    >
      {renderCountOrIcon()}
      <span>{label}</span>
    </Button>
  );
};
